import React from 'react';
import { useIntl } from 'react-intl';

// @mui/material components
import { Box, IconButton } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

/** The move up / move down / delete action column of a CTA link row. */
export default function CtaLinkRowActions({ onMoveUp, onMoveDown, onDelete, canMoveUp, canMoveDown }) {
    const intl = useIntl();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
            <IconButton
                size="small"
                onClick={onMoveUp}
                disabled={!canMoveUp}
                aria-label={intl.formatMessage({ id: 'category.form.ctaLinks.moveUp' })}
            >
                <ArrowUpwardIcon fontSize="small" />
            </IconButton>
            <IconButton
                size="small"
                onClick={onMoveDown}
                disabled={!canMoveDown}
                aria-label={intl.formatMessage({ id: 'category.form.ctaLinks.moveDown' })}
            >
                <ArrowDownwardIcon fontSize="small" />
            </IconButton>
            <IconButton
                size="small"
                onClick={onDelete}
                aria-label={intl.formatMessage({ id: 'category.form.ctaLinks.delete' })}
            >
                <DeleteOutlineIcon fontSize="small" />
            </IconButton>
        </Box>
    );
}
